import { USER_ROLE } from '../../Constants/MobileMenuConstants'

const RoleReducer = (state = false, action: { type: string; payload: boolean }) => {
  switch (action.type) {
    case USER_ROLE:
      return action.payload
    default:
      return state
  }
}

export default RoleReducer
